export default __webpack_public_path__ + "static/media/heade_services.e5084732.jpg";